var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.43188,
    y: 1.16666,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#825DFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0927 9.59524C10.0927 9.31909 9.86881 9.09524 9.59267 9.09524C9.31653 9.09524 9.09267 9.31909 9.09267 9.59524H10.0927ZM9.09267 14.9524C9.09267 15.2285 9.31653 15.4524 9.59267 15.4524C9.86881 15.4524 10.0927 15.2285 10.0927 14.9524H9.09267ZM8.25338 6.38095V6.88095H13.6105V6.38095V5.88095H8.25338V6.38095ZM15.2177 7.98809H14.7177V13.3452H15.2177H15.7177V7.98809H15.2177ZM13.6105 14.9524V14.4524H8.25338V14.9524V15.4524H13.6105V14.9524ZM6.64624 13.3452H7.14624V7.98809H6.64624H6.14624V13.3452H6.64624ZM8.25338 14.9524V14.4524C7.64192 14.4524 7.14624 13.9567 7.14624 13.3452H6.64624H6.14624C6.14624 14.509 7.08964 15.4524 8.25338 15.4524V14.9524ZM15.2177 13.3452H14.7177C14.7177 13.9567 14.222 14.4524 13.6105 14.4524V14.9524V15.4524C14.7743 15.4524 15.7177 14.509 15.7177 13.3452H15.2177ZM13.6105 6.38095V6.88095C14.222 6.88095 14.7177 7.37664 14.7177 7.98809H15.2177H15.7177C15.7177 6.82435 14.7743 5.88095 13.6105 5.88095V6.38095ZM8.25338 6.38095V5.88095C7.08964 5.88095 6.14624 6.82435 6.14624 7.98809H6.64624H7.14624C7.14624 7.37664 7.64192 6.88095 8.25338 6.88095V6.38095ZM9.59267 9.59524H9.09267V14.9524H9.59267H10.0927V9.59524H9.59267ZM6.9141 9.32738V9.82738H14.9498V9.32738V8.82738H6.9141V9.32738Z",
    fill: "#825DFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionAnalysis);
export default __webpack_public_path__ + "static/media/question-analysis.27478aaae72067829763e074ec6aec5e.svg";
export { ForwardRef as ReactComponent };